import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "components/AuthLogin/AuthContext";
import BlogEditor from "./BlogEditor";
import FailModal from "./BlogModal/FailModal";

const BlogWrite: React.FC = () => {
    const navigate = useNavigate();
    const { getCookie } = useAuth();
    const [isFailModalOpen, setIsFailModalOpen] = useState(false);

    const handleSubmit = async (formData: FormData) => {
        const apiToken = getCookie('apiToken');

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/posts`, {
                method: "POST",
                headers: { 'Authorization': `Bearer ${apiToken}` },
                body: formData,
            });

            if (!response.ok) throw new Error("Network response was not ok");

            const responseData = await response.json();
            navigate(`/blog-single/${responseData.contents.id}`);
        } catch (error) {
            console.error("Error:", error);
            setIsFailModalOpen(true);
        }
    };

    return (
        <>
            <BlogEditor onSubmit={handleSubmit} submitButtonText="발행" />
            <FailModal
                isOpen={isFailModalOpen}
                onClose={() => setIsFailModalOpen(false)}
                title="오류가 발생했어요"
                mainMessage="글 발행에 실패했어요."
                subMessage="다시 시도해 주세요."
            />
        </>
    );
};

export default BlogWrite;
